import { ModuleI } from "../../interfaces";

export const findClosestModuleByPath = (
  modules: ModuleI[],
  path: string
): ModuleI | null => {
  let closestMatch: ModuleI | null = null;

  const searchModule = (items: ModuleI[]) => {
    for (const module of items) {
      if (path.startsWith(module.to)) {
        if (!closestMatch || module.to.length > closestMatch.to.length) {
          closestMatch = module;
        }
      }
      if (module.children && module.children.length > 0) {
        searchModule(module.children);
      }
    }
  };

  searchModule(modules);
  return closestMatch;
};

export const normalizePath = (path: string) => {
  return path.replace(/\/\d+/g, "/:id").toLowerCase();
};

export const extractModuleBase = (path: string): string => {
  const normalizedPath = path.replace(/\/\d+/g, "/:id").toLowerCase();
  let pathSegments = normalizedPath.split("/").filter(Boolean);

  if (pathSegments.includes("edit")) {
    pathSegments.pop();
  }

  if (pathSegments.length <= 1) {
    return `/${pathSegments[0] || ""}`;
  }

  if (pathSegments.length === 2) {
    return `/${pathSegments[0]}`;
  }

  return `/${pathSegments.slice(0, -1).join("/")}`;
};